import { Capacitor } from '@capacitor/core';
import { Browser } from '@capacitor/browser';

/**
 * Open a Stripe Checkout or Customer Portal URL in a way that works on both
 * web and Capacitor native.
 *
 * - Web: classic same-tab redirect. Stripe redirects back to
 *   `https://ravecave.app/settings?upgrade=success`, the PlanSection
 *   `useEffect` reads the query param and shows the toast.
 * - Native: opens Stripe in an in-app Custom Tab (Chrome on Android).
 *   When the user closes the tab, the Firestore real-time listener on
 *   the user's profile picks up the subscription change automatically —
 *   no deep-link return is required for the beta. The toast on success
 *   would be added via a `useEffect` watching `isPremium` if desired.
 */
export async function openStripeCheckout(url: string): Promise<void> {
  if (Capacitor.isNativePlatform()) {
    await Browser.open({ url, presentationStyle: 'popover' });
    return;
  }
  window.location.href = url;
}
